<ng-container *ngIf="!isLoading">
    <div>
        <div style="margin-left: 70%;  margin-bottom: 2%">
         

       <button class="noPrint"
        style="margin-right: 2%; margin-left: 2%"
        mat-raised-button color="primary"
        (click)="printPage()">
         Print
       </button>

            <button class="noPrint" style="margin-top: 2% 2% 0 2%;"
                (click)="exportExcel('Datewise_Subscription_Report')" mat-raised-button color="primary">
                Export
            </button>
            <button mat-dialog-close class="btn noPrint">
                Close
            </button>
        </div>
    </div>
    <div *ngIf="datewisedata == 'first'">
        <div class="container" id="print-section">
            <table class="table table-bordered">
                <thead>

        <tr>
            <th [attr.colspan]="totalth - 5" class="largeHeading"
              style="text-align: center; font-size: 13px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 13px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ today | date:'dd-MM-yyyy' }}
            </th>
          </tr>

            <tr>
            <th [attr.colspan]="totalth - 8" class="largeHeading"
              style="text-align: center; font-size: 13px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ - दिनांकानुसार/वर्गणीदार
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 13px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ startDate | date:'dd-MM-yyyy' }}
            </th>
            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 13px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              पर्यंत - {{ endDate | date:'dd-MM-yyyy' }}
            </th>
          </tr>

                

                    <tr>
                        <th rowspan="1" style="border-bottom:2px solid black; border-top:2px solid black;border-left:2px solid black;">कार्यालय प्रतिनिधींचे नाव</th>
                      
                         <!-- <th rowspan="1" style="border-top:2px solid black; border-bottom:2px solid black; border-left:2px solid black;">{{data.country}}</th> -->
                        <!-- <th rowspan="1" style="border-top:2px solid black; border-bottom:2px solid black; border-right:2px solid black;">{{date.state}}</th> -->
                          <th style="border-top:2px solid black;border-left:2px solid black; border-bottom:2px solid black; border-right:2px solid black;"colspan="1" >{{countryNameNew}}</th>
                           <th style="border-top:2px solid black;border-left:2px solid black; border-bottom:2px solid black; border-right:2px solid black;" colspan="1" > {{stateNameNew}}</th>
                        <th colspan="5" style="border-bottom:2px solid black; border-top:2px solid black; border-left:2px solid black; border-right:2px solid black;">एकूण</th>
                        <ng-container *ngFor="let data of subTypesName">
                            <th *ngIf="data.isVisible" colspan="4" style="border-bottom:2px solid black; border-top:2px solid black; border-left:2px solid black; border-right:2px solid black;">{{ data.name }}</th>
                           
                        </ng-container>
                    
                    </tr>
                    <tr>
                       
                      <th  style="border-left:2px solid black;"colspan="1"> </th>
                       
                        <th style="border-top:2px solid black; border-bottom:2px solid black; border-left:2px solid black;">जिल्हा</th>
                        <th style="border-top:2px solid black; border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black;">तालुका</th>
                     
                          <th style="border-bottom: 2px solid black;border-left: 2px solid black;">वर्गणी दार संख्या</th>
            <th style="border-bottom: 2px solid black;">नवीन</th>
            <th style="border-bottom: 2px solid black;">नूतनीकरण</th>
            <th style="border-bottom: 2px solid black;">नूतनी-बाकी</th>
            <th style="border-bottom: 2px solid black;border-right: 2px solid black;">रक्कम</th>
                        <ng-container *ngFor="let data of subTypesName">
                            <th style="border-bottom: 2px solid black;border-left: 2px solid black;"*ngIf="data.isVisible"colspan="1">नवीन</th>
              <th style="border-bottom: 2px solid black;"*ngIf="data.isVisible"colspan="1">नूतनीकरण</th>
              <th style="border-bottom: 2px solid black;" *ngIf="data.isVisible"colspan="1">नूतनी-बाकी</th>
                 <th style="border-bottom: 2px solid black;;border-right: 2px solid black;" *ngIf="data.isVisible"colspan="1">रक्कम</th>   
                        </ng-container>
                    </tr>
                </thead>
                <tbody>
                   
               
      


  


<ng-container *ngFor="let data of finalData">

  <!-- 🟢 Office Representative Header -->
  <tr *ngIf="data._isOfficeRepHeader">
    <td colspan="3" style="font-weight: bold;  border: 2px solid black;">
      {{ data.office_rep_name }}
    </td>
    <td colspan="1"></td>
            <td colspan="1"></td>
              <td colspan="1"></td>
                <td></td>
                  <td style=" border-right: 2px solid black;"  colspan="1"></td>
                   <!-- <td colspan="1"></td> -->
            <!-- <td colspan="1"></td> -->
              <!-- <td colspan="1"></td> -->
                <!-- <td colspan="1"></td> -->
                  <!-- <td style=" border-right: 2px solid black;" colspan="1"></td> -->
      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
        
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td  style=" border-right: 2px solid black;" colspan="1"></td>
        </ng-container>
      </ng-container>

  </tr>

  <!-- 🔵 Individual Representative Data -->
  <tr *ngIf="data._isIndividual && !data.office_rep_name">
    <td colspan="1" style="font-weight: bold; padding-left: 20px; border: 1px solid black;border-left: 2px solid black;border-right: 2px solid black;">
      {{ data.rep_name }} – {{ data.rep_taluka }}
    </td>
    <td style="font-weight: bold;border-left:2px solid black;border-right:2px solid black;">{{ data.district_name }}</td>
    <td style="border-right:2px solid black;" colspan="1"></td>
    <td style="text-align: right; border: 1px solid black;">{{ data['वर्गणी दार संख्या'] || '0' }}</td>
    <td style="text-align: right; border: 1px solid black;">{{ data['नवीन'] || '0' }}</td>
    <td style="text-align: right; border: 1px solid black;">{{ data['नूतनीकरण'] || '0' }}</td>
    <td style="text-align: right; border: 1px solid black;">{{ data['नूतनी-बाकी'] || '0' }}</td>
    <td style="text-align: right; border: 1px solid black;border-right:2px solid black;">{{ data['रक्कम'] || '0' }}</td>

    <ng-container *ngFor="let sub of subTypesName">
      <ng-container *ngIf="sub.isVisible">
        <td style="text-align: right; border: 1px solid black;">{{ data[getKey(sub.name) + '_नवीन'] || '0' }}</td>
        <td style="text-align: right; border: 1px solid black;">{{ data[getKey(sub.name) + '_नूतनीकरण'] || '0' }}</td>
        <td style="text-align: right; border: 1px solid black;">{{ data[getKey(sub.name) + '_नूतनी-बाकी'] || '0' }}</td>
        <td style="text-align: right; border: 1px solid black;border-right:2px solid black;">{{ data[getKey(sub.name) + '_एकूण'] || '0' }}</td>
      </ng-container>
    </ng-container>
  </tr>

  <!-- 🔴 Representative Subtotal -->
  <tr *ngIf="data._isRepTotal">
    <td colspan="3" style="font-weight: bold; border: 2px solid black;border-top:2px solid black;border-bottom:2px solid black;font-weight: bold;">{{ data.rep_name }} – एकूण</td>
    <td style="text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black;font-weight: bold;">{{ data['वर्गणी दार संख्या'] || '0' }}</td>
    <td style="text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black;font-weight: bold;">{{ data['नवीन'] || '0' }}</td>
    <td style="text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black;font-weight: bold;">{{ data['नूतनीकरण'] || '0' }}</td>
    <td style="text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black;font-weight: bold;">{{ data['नूतनी-बाकी'] || '0' }}</td>
    <td style="text-align: right; border: 1px solid black;border-right:2px solid black;border-top:2px solid black;border-bottom:2px solid black;font-weight: bold;">{{ data['रक्कम'] || '0' }}</td>
    <ng-container *ngFor="let sub of subTypesName">
      <ng-container *ngIf="sub.isVisible">
        <td style="text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black;font-weight: bold;">{{ data[getKey(sub.name) + '_नवीन'] || '0' }}</td>
        <td style="text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black;font-weight: bold;">{{ data[getKey(sub.name) + '_नूतनीकरण'] || '0' }}</td>
        <td style="text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black;font-weight: bold;">{{ data[getKey(sub.name) + '_नूतनी-बाकी'] || '0' }}</td>
        <td style="text-align: right; border: 1px solid black;border-right:2px solid black;border-top:2px solid black;border-bottom:2px solid black;font-weight: bold;">{{ data[getKey(sub.name) + '_एकूण'] || '0' }}</td>
      </ng-container>
    </ng-container>
  </tr>

  <!-- 🟠 Office Total -->
  <tr *ngIf="data._isOfficeTotal">
    <td colspan="3" style="font-weight: bold;  border: 1px solid black;border-right:2px solid black;border-left:2px solid black;">{{ data.office_rep_name }} – एकूण</td>
    <td style="font-weight: bold;text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black;">{{ data['वर्गणी दार संख्या'] || '0' }}</td>
    <td style="font-weight: bold;text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black;">{{ data['नवीन'] || '0' }}</td>
    <td style="font-weight: bold;text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black;">{{ data['नूतनीकरण'] || '0' }}</td>
    <td style="font-weight: bold;text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black;">{{ data['नूतनी-बाकी'] || '0' }}</td>
    <td style="font-weight: bold;text-align: right; border: 1px solid black;border-right:2px solid black;border-top:2px solid black;border-bottom:2px solid black;">{{ data['रक्कम'] || '0' }}</td>
    <ng-container *ngFor="let sub of subTypesName">
      <ng-container *ngIf="sub.isVisible">
        <td style="font-weight: bold;text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black;border-top:2px solid black;border-bottom:2px solid black;">{{ data[getKey(sub.name) + '_नवीन'] || '0' }}</td>
        <td style="font-weight: bold;text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black;border-top:2px solid black;border-bottom:2px solid black;">{{ data[getKey(sub.name) + '_नूतनीकरण'] || '0' }}</td>
        <td style="font-weight: bold;text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black;border-top:2px solid black;border-bottom:2px solid black;">{{ data[getKey(sub.name) + '_नूतनी-बाकी'] || '0' }}</td>
        <td style="font-weight: bold;text-align: right; border: 1px solid black;border-right:2px solid black;border-top:2px solid black;border-bottom:2px solid black;">{{ data[getKey(sub.name) + '_एकूण'] || '0' }}</td>
      </ng-container>
    </ng-container>
  </tr>

  <!-- 🟡 Grand Total -->
  <tr *ngIf="data.name === 'एकूण'" class="smallHeading">
    <td colspan="3" style="border: 2px solid black;font-weight: bold;">{{ data.name }}</td>
    <td style="text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black">{{ data['वर्गणी दार संख्या'] || '0' }}</td>
    <td style="text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black">{{ data['नवीन'] || '0' }}</td>
    <td style="text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black">{{ data['नूतनीकरण'] || '0' }}</td>
    <td style="text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black">{{ data['नूतनी-बाकी'] || '0' }}</td>
    <td style="text-align: right; border: 1px solid black;border-right:2px solid black;border-top:2px solid black;border-bottom:2px solid black">{{ data['रक्कम'] || '0' }}</td>
    <ng-container *ngFor="let sub of subTypesName">
      <ng-container *ngIf="sub.isVisible">
        <td style="text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black">{{ data[getKey(sub.name) + '_नवीन'] || '0' }}</td>
        <td style="text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black">{{ data[getKey(sub.name) + '_नूतनीकरण'] || '0' }}</td>
        <td style="text-align: right; border: 1px solid black;border-top:2px solid black;border-bottom:2px solid black">{{ data[getKey(sub.name) + '_नूतनी-बाकी'] || '0' }}</td>
        <td style="text-align: right; border: 1px solid black;border-right:2px solid black;border-top:2px solid black;border-bottom:2px solid black">{{ data[getKey(sub.name) + '_एकूण'] || '0' }}</td>
      </ng-container>
    </ng-container>
  </tr>

</ng-container>



                </tbody>
            </table>
        </div>
    </div>

</ng-container>
<div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
</div>